import { Card, Row } from '@components'
import Column from '@components/column'
import { style30Percent, styleRowWrapper } from '@components/styles'
import Typography from '@components/typography'
import { Constant } from '@utils'
import { Avatar } from '../style'

const UserInfo = ({ user }: any) => {
  const avatar = user?.avatar
    ? `${process.env.BUCKET_URL}/${user?.avatar}`
    : Constant.defaultUser
  return (
    <>
      <Card
        radius={8}
        customStyle={[
          { padding: '20px 15px', alignItems: 'center', display: 'flex' },
        ]}
      >
        <Row styleRow={[styleRowWrapper]} alignItems="center">
          <Column styleColumn={style30Percent} alignItems="center">
            <Avatar src={avatar} />
          </Column>
          <Column rowGap={10}>
            <Row colGap={4} alignItems="center">
              <Typography
                content={user?.name}
                size={12}
                weigth={400}
                lineHeight={19}
              />
            </Row>

            <Row>
              <Typography
                content={user?.email}
                size={12}
                weigth={400}
                lineHeight={19}
              />
            </Row>
            <Row>
              <Typography
                content={user?.phoneNo}
                size={12}
                weigth={400}
                lineHeight={19}
              />
            </Row>
          </Column>
        </Row>
      </Card>
    </>
  )
}

export default UserInfo
